import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getTaskByCode } from '../services/api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ShieldAlert, TreePine } from 'lucide-react';
import { companyInfo } from '../data/mock';

const TaskLinkPage = () => {
  const { code } = useParams();
  const { isAuthenticated, loading, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) return;
    if (!isAuthenticated) {
      localStorage.setItem('pendingTaskCode', code);
      navigate(`/portal/login?redirect=${encodeURIComponent(`/task/${code}`)}`, { replace: true });
      return;
    }
    getTaskByCode(code)
      .then((task) => {
        localStorage.removeItem('pendingTaskCode');
        if (isAdmin) {
          navigate(`/portal/admin/employee-tasks?task=${task.id}`, { replace: true });
        } else {
          navigate(`/portal/employee/tasks/${task.id}`, { replace: true });
        }
      })
      .catch((err) => {
        localStorage.removeItem('pendingTaskCode');
        setError(err.response?.data?.detail || 'Darba uzdevums nav atrasts');
      });
  }, [code, loading, isAuthenticated, isAdmin, navigate]);

  return (
    <div className="min-h-screen bg-[#f8faf8] flex flex-col items-center justify-center p-4" data-testid="task-link-page">
      <div className="flex items-center gap-3 mb-8">
        <img src={companyInfo.logo.dark} alt={companyInfo.name} className="h-10 w-auto" />
        <span className="font-bold text-[#1F3D2B]">{companyInfo.name}</span>
      </div>
      {error ? (
        <Card className="w-full max-w-md border-0 shadow-xl" data-testid="task-link-error-card">
          <CardContent className="py-10 text-center space-y-4">
            <div className="w-14 h-14 mx-auto rounded-full bg-red-50 flex items-center justify-center">
              <ShieldAlert className="w-7 h-7 text-red-600" />
            </div>
            <p className="text-lg font-semibold text-[#2E2E2E]" data-testid="task-link-error">{error}</p>
            <p className="text-sm text-[#2E2E2E]/60">Ja uzskatāt, ka tā ir kļūda, sazinieties ar administratoru.</p>
            <div className="flex flex-col sm:flex-row gap-2 justify-center pt-2">
              <Button variant="outline" onClick={() => navigate('/portal')} data-testid="task-link-back-portal">
                Uz portālu
              </Button>
              <Button variant="ghost" onClick={async () => { await logout(); navigate(`/task/${code}`); }} data-testid="task-link-switch-user">
                Pieslēgties ar citu lietotāju
              </Button>
            </div>
          </CardContent>
        </Card>
      ) : (
        <div className="text-center space-y-3" data-testid="task-link-loading">
          <div className="w-10 h-10 border-4 border-[#1F3D2B] border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-[#2E2E2E]/60 flex items-center gap-2 justify-center">
            <TreePine className="w-4 h-4" /> Atver darba uzdevumu...
          </p>
        </div>
      )}
    </div>
  );
};

export default TaskLinkPage;
